<header class="modal__header">
  <h2 id="modalLabel" [hidden]="content.logoUrl" [ngStyle]="content.color && { color: 'black' }">{{ content.text?.title }}</h2>
  @if (content.logoUrl) {
    <img class="modal__logo" [src]="content.logoUrl" [attr.alt]="content.text?.title" />
  }
  @if (!content.disableDefaultClose) {
    <button class="button modal__button--close" type="button" (click)="close()" [attr.aria-label]="'general.label.close' | translate">
      <i class="icon icon-ui-close--sm" [ngStyle]="content.color && { 'background-color': '#' + content.color.color }"></i>
    </button>
  }
</header>
<div class="modal__content">
  <div class="modal__text" [internalInnerHtml]="content.text?.body" [userEventSource]="userEventSource"></div>
</div>
<div [ngClass]="content.hideCancelButton ? 'modal__footer' : 'modal__footer--full-width-ends'">
  @if (content.hideCancelButton !== true) {
    <button
      type="button"
      class="button button--secondary"
      [style.color]="content.color && '#' + content.color.color"
      (click)="cancel($event)"
    >
      <span>{{ content.cancelText }}</span>
    </button>
  }
  <button
    type="button"
    class="button"
    [ngClass]="content.hideCancelButton ? 'button--primary' : 'button--cta'"
    [style.background-color]="content.color && '#' + content.color.color"
    [airButtonLoading]="isLoading"
    (click)="confirmAction($event)"
  >
    <span>{{ content.confirmText }}</span>
  </button>
</div>
